module.exports = __webpack_public_path__ + "media/img/agents-cards-01-a8cffe75820343b68fcb77858c4c867a.jpg";